import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { computed, unref } from '@vue/composition-api';
import { useState } from 'vuex-composition-helpers';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import useVueProxy from '@ve/services/useVueProxy';

export default () => {
    const { $root } = useVueProxy();
    const {
        hotelCategories,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['hotelCategories']);

    const selected = computed({
        get: () => unref(hotelCategories),
        set: (value) => {
            $root?.$emit('hotel-categories-filter-changed', value);
        },
    });

    const allChecked = computed({
        get: () => !unref(selected).length,
        set: (value) => {
            if (value) {
                selected.value = [];
            }
        },
    });

    return {
        allChecked,
        selected,
    };
};